import Link from 'next/link';
import { useMediaQuery } from 'react-responsive';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { LinkProps, MediaType } from '@repo/ui/src/types';

interface Props {
  image: MediaType;
  link: LinkProps;
  title: string;
  description: string;
}

const PressArticle = ({ image, link, title, description }: Props) => {
  const linkObj = buildLinkObj(link);
  const imgUrl = buildImageSrc(image ?? null, 690, 6, 5);
  const isMediumOrSmallerScreen = useMediaQuery({
    query: '(max-width: 767px)',
  });
  return (
    <div className="card mx-2">
      {link && link.externalLink ? (
        <Link
          rel={getRel(linkObj)}
          href={linkObj.href}
          locale={false}
          target="_blank"
          className="tw-text-text-400"
        >
          <LazyLoadImage
            imgComponent={
              <img
                className="card-img-top press-carousel-img-fluid mb-1"
                src={imgUrl}
                alt={`${title}image`}
              />
            }
          />
          {isMediumOrSmallerScreen ? (
            <h6 className="card-title d-flex justify-content-left mt-4 carousel-title">{title}</h6>
          ) : (
            <h4 className="card-title d-flex justify-content-left mt-4 carousel-title text-left">
              {title}
            </h4>
          )}
          <p>{description}</p>
        </Link>
      ) : (
        <a rel={getRel(linkObj)} className="card-link" href={linkObj.href}>
          <LazyLoadImage
            imgComponent={
              <img
                className="card-img-top press-carousel-img-fluid mb-1"
                src={imgUrl}
                alt={`${title}image`}
              />
            }
          />
          {isMediumOrSmallerScreen ? (
            <h6 className="card-title d-flex justify-content-left mt-4 carousel-title">{title}</h6>
          ) : (
            <h4 className="card-title d-flex justify-content-left mt-4 carousel-title text-left">
              {title}
            </h4>
          )}
          <p>{description}</p>
        </a>
      )}
    </div>
  );
};

export default PressArticle;
